import { Icon } from "./Icon.tsx";

/** "Create empty project" icon. */
export function PlusIcon() {
  return (
    <Icon>
      <path d="M12 5v14" />
      <path d="M5 12h14" />
    </Icon>
  );
}
